import React from "react";
import { MainRentCar } from "../RentACar";

export const RentACar = () => {
  return (
    <>
      <MainRentCar />
    </>
  );
};
